import { render, staticRenderFns } from "./variant.vue?vue&type=template&id=99e733c2&"
import script from "./variant.vue?vue&type=script&lang=js&"
export * from "./variant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports